// @flow

import React from 'react';
import styled, { withTheme } from 'styled-components';

import Radio from 'common/domain/radio';

const StatsLogo = styled.img`
  width: auto;
  height: 70px;
`;

const StationLogo = styled.img`
  width: auto;
  height: 70px;
  float: right;
`;

type Props = {
  radio: ?Radio,
  theme: any,
};

function PrintingLogo(props: Props) {
  return (
    <div>
      <StatsLogo src={props.theme.images.logo} alt="Logo" />
      {props.radio &&
      <StationLogo src={props.radio.logo} alt={props.radio.name} />
      }
    </div>
  );
}

export default withTheme(PrintingLogo);




// WEBPACK FOOTER //
// ./src/common/modules/printing/components/PrintingLogo.js